import '@ver-uds/styles';
import { EveHeader, EveRoutes } from '@ver-uds/e-verify';
import React from 'react';
import ReactGA from 'react-ga4';
import { useEnvironment } from '../../context/Environment/EnvironmentContext';
import Environment from '../../constants/Environment';
import { useDashboard } from '../../context/Dashboard/DashboardContext';
import { GetAuthServiceMFA } from '../../utils/mfaAuthUtils';

const DashboardHeader = (): JSX.Element => {
  const { ENVIRONMENT_NAME } = useEnvironment();

  // mfa - login.gov logout
  const authService = GetAuthServiceMFA();
  const useMFALogout = () => () => {
    try {
      authService.mfaLogoutRedirect();
    } catch (error) {
      throw new Error(`Error within header: ${error}`);
    }
  };

  if (!ReactGA.isInitialized) {
    ReactGA.initialize(ENVIRONMENT_NAME === Environment.PROD ? 'G-HXH7SL0ZYG' : 'G-KRTN40GWV3', {
      // eslint-disable-next-line @typescript-eslint/camelcase
      gtagOptions: { send_page_view: false },
    });
  }

  // Get name fields from user profile
  const { profile } = useDashboard();
  const firstName = profile?.firstName || 'User';
  const lastName = profile?.lastName || '';

  const onDashboardNotFound = window.location.pathname.includes(EveRoutes.DASHBOARD_NOT_FOUND);

  return (
    <EveHeader
      user={{ firstName, lastName, roles: [], mfaEnabled: true }}
      showSelfTestLink={false}
      hideNavItems
      hideUserMenu={onDashboardNotFound}
      onLogOut={useMFALogout}
      hideNavigateToDashboard
    />
  );
};

export default DashboardHeader;
